import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import InfoCard from "components/InfoCard/index";
import FormCRU from "./FormCRU";
import TableAM from "./TableAM";
import {
  callApi,
  callApiAsync,
  getDosageV2,
  postCreateUpdateDosageV2,
  deleteDosage,
  getUnitListTime,
  getUnitDurationListTime
} from "api/apiList";
import { callStartImpact } from "actions/Impact";

const DosageDialog = () => {
  const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const { impactStartDate, consentSigned, isCIRequired, healthData } = useSelector(({ impact }) => impact);

  const [open, setOpen] = useState(false);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState(null);
  const [dosageList, setDosageList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [unitDurationList, setUnitDurationList] = useState([]);

  const msgStartImpactRequired = IntlGetText("impact.startImpactRequired");
  const msgConsentRequired = IntlGetText("impact.consentRequired");
  const msgPrescriptionRequired = IntlGetText("core.msgPrescriptionRequired");

  const handleClickOpen = () => {
    if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
    if(!impactStartDate){
      dispatch(callStartImpact(true));
      return;
    }
    if(isCIRequired && !consentSigned){
        NotificationManager.warning(msgConsentRequired);
        return;
    }if(!(healthData?.dosage?.id)){
      NotificationManager.warning(msgPrescriptionRequired);
      return;
  }
    setOpen(true);
  };
  const handleRequestClose = () => {
    setOpen(false);
  };

  const handleOpenCRU = () => {
    setOpenCRU(true);
  };
  const handleRequestCloseCRU = () => {
    setOpenCRU(false);
  };
  const handleRequestCloseDel = () => {
    setOpenDeleteDialog(false);
  };

  const loadDosageTable = () => {
    callApi(
      () => getDosageV2(selectedPrescription.id),
      setDosageList
    );
  };

  useEffect(() => {
    loadDosageTable();
    callApi(
      () => getUnitListTime(),
      setUnitList
    );
    callApi(
      () => getUnitDurationListTime(),
      setUnitDurationList
    );
  }, []);

  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdateDosageV2(data),
      setDosageList
    );
  };

  const handleDelete = () => {
    callApi(
      () => deleteDosage(currentRowObj.id),
      (data) => {
        setDosageList(data);
        handleRequestCloseDel();
      }
    );
  };

  useEffect(() => {
    if (open) {
      loadDosageTable();
    }
  },[open]);

  return (
    <div>
      <InfoCard
        data={{
          icon: "collection-plus",
          title: IntlGetText("core.dosage"),
          subTitle: IntlGetText("medicineDelivery.cardSubTitle"),
          color: "#757575",
        }}
        onClickBox={handleClickOpen}
      />
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        disableBackdropClick={true}
        onClose={handleRequestClose}
      >
        <DialogTitle>
          <IntlMessages id="core.dosage" />
        </DialogTitle>
        <DialogContent>
          <TableAM
            data={dosageList}
            handleOpenCRU={handleOpenCRU}
            handleOpenDel={() => setOpenDeleteDialog(true)}
            setCurrentRowObj={setCurrentRowObj}
          />
          <FormCRU
            openCRU={openCRU}
            handleRequestClose={handleRequestCloseCRU}
            rowObj2={currentRowObj}
            impactId={selectedPrescription.impactId}
            prescription={selectedPrescription}
            handleCreateUpdate={handleCreateUpdate}
            unitList={unitList}
            unitDurationList={unitDurationList}
          />
          <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={openDeleteDialog}
            disableBackdropClick={true}
            onClose={handleRequestCloseDel}
          >
            <DialogTitle>
              <IntlMessages id="additionalMedications.MsgDelConfirmation" />
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleRequestCloseDel} color="secondary">
                <IntlMessages id="core.cancel" />
              </Button>
              <Button onClick={handleDelete} color="primary">
                <IntlMessages id="core.accept" />
              </Button>
            </DialogActions>
          </Dialog>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRequestClose} color="secondary">
            <IntlMessages id="core.close" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DosageDialog;
